export default __webpack_public_path__ + "static/electronic_white_board_w.c6f045db99094641df177b4a8096ce8a.svg";